import { render, staticRenderFns } from "./lineAbout.vue?vue&type=template&id=628749fa&scoped=true"
import script from "./lineAbout.vue?vue&type=script&lang=js"
export * from "./lineAbout.vue?vue&type=script&lang=js"
import style0 from "./lineAbout.vue?vue&type=style&index=0&id=628749fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628749fa",
  null
  
)

export default component.exports